import { message, Switch } from "antd"
import { useSelector, useDispatch } from "react-redux"
import { setMenuType } from "src/redux/menuSlice"
import { useEffect, useState } from "react"
import STORAGE from "src/lib/storage"

const LuxurySwitch = () => {
  const dispatch = useDispatch()
  const permissions = localStorage.getItem(STORAGE.PERMISSIONS) || ""
  const { currentType } = useSelector(state => state.menu)
  const [isAdmin, setIsAdmin] = useState(currentType === "admin")

  const permissionSwitch =
    permissions.includes("system.htc") &&
    permissions.includes("system.poolData")

  useEffect(() => {
      setIsAdmin(currentType === "admin")
  }, [currentType])

  const handleToggle = checked => {
    if(!permissions){
      message.warning("Không có quyền")
      return
    }
    const newType = checked ? "admin" : "pullData"
    setIsAdmin(checked)
    dispatch(setMenuType(newType))
  }

  return (
    <div>
      <div className="flex flex-col items-center gap-2 text-center">
        <Switch
          checked={isAdmin}
          onChange={handleToggle}
          checkedChildren="HTC"
          unCheckedChildren="Pool Data"
          size="default"
          className="scale-125 bg-gray-200"
        />
        <span
          className={`font-semibold text-lg tracking-wide transition-all duration-500 ${isAdmin ? "text-yellow-100" : "text-cyan-100"
            }`}
        ></span>
      </div>
    </div>
  )
}

export default LuxurySwitch
